export default {
  common: {
    loading: "加载中...",
    cancel: "取消",
    confirm: "确定",
    noMore: "没有更多数据了",
    loadMore: "上拉加载更多",
    loadingMore: "加载更多...",
    refreshSuccess: "刷新成功",
    refreshFailed: "刷新失败",
    landscapeTip: "请将手机竖屏使用以获得更好的体验",
    submit: "提交",
    all: "全部",
    language: "语言",
  },
  tabBar: {
    home: "首页",
    notice: "消息",
    profile: "我的",
  },
  notice: {
    title: "消息通知",
    tabs: {
      notification: "通知",
      reply: "回复我的",
      mention: "{'@'}我的",
      like: "点赞",
    },
    replyComment: "{username} 回复了你的评论",
    replyPost: "{username} 回复了你的帖子",
    mentionComment: "{username} {'@'}了你的评论",
    mentionPost: "{username} {'@'}了你的帖子",
    likeComment: "{username} 点赞了你的评论",
    likePost: "{username} 点赞了你的帖子",
    system: "系统通知",
    empty: "暂无消息",
  },
  home: {
    gameName: "Puzzles & Survival",
    unboundRole: "未绑定角色",
    pleaseLogin: "请先登入",
    loginNow: "登陆",
    loginInSuccess: "登录成功",
    signIn: "签到",
    hasSigned: "已签到",
    signInFailedTip: "签到失败，请稍后再试",
    signSuccess: "签到成功",
    signFailed: "签到失败",
    goToShop: "前往积分中心",
    pullToRefresh: "下拉刷新",
    releaseToRefresh: "释放刷新",
    sortByTime: "最新",
    sortByLastPost: "最近评论",
    tags: {
      recommend: "推荐",
      chats: "交流",
      guide: "攻略",
      activity: "活动",
      news: "新闻",
    },
  },
  post: {
    title: "帖子",
    create: {
      title: "发帖",
      submit: "发布",
      titlePlaceholder: "请填写标题",
      contentPlaceholder: "这刻你想说的...",
      image: "图片",
      video: "视频",
      mention: "{'@'}",
      selectBoard: "选择板块",
      topicLabel: "话题",
      imageSizeLimit: "图片大小不能超过5MB",
      videoSizeLimit: "视频大小不能超过50MB",
      titleEmpty: "标题不能为空",
      contentEmpty: "内容不能为空",
      submitting: "发布中...",
      success: "发布成功",
      failed: "发布失败",
      imageUploading: "图片上传中，请稍候...",
      imageUploadSuccess: "图片上传成功",
      imageUploadFailed: "图片上传失败",
      videoUploading: "视频上传中，请稍候...",
      videoUploadSuccess: "视频上传成功",
      videoUploadFailed: "视频上传失败",
      maxCharsReached: "已达到最大字符数限制 ({max} 字符)",
      invalidFileType: "不支持的文件类型",
      fileTooLarge: "文件大小超过限制（最大 {maxSize}）",
    },
  },
  postDetail: {
    writeSomething: "说点什么...",
    sending: "发送中...",
    sendSuccess: "发送成功",
    sendFailed: "发送失败",
    loadFailed: "加载失败",
    noContent: "暂无内容",
    allReplies: "全部回复",
    onlyAuthor: "只看作者",
    earliest: "最早回复",
    latest: "最新回复",
    allComments: "全部{num}条回复",
    replyTo: "回复",
    author: "作者",
    floor: "楼",
    reply: "回复",
    favoriteSuccess: "收藏成功",
    cancelFavorite: "已取消收藏",
    viewOriginalPost: "查看原帖",
    commentTooShort: "评论内容不能少于5个字",
    translate: "翻译",
    translating: "翻译中...",
    translateSuccess: "翻译成功",
    translateFailed: "翻译失败",
    translatedTo: "已翻译为",
  },
  operateModal: {
    title: "操作",
    copyLink: "复制链接",
    delete: "删除",
    shareToGame: "分享到游戏内",
    copySuccess: "复制成功",
    confirmDelete: "确定要删除这个帖子吗？",
    deleteSuccess: "删除成功",
    deleteFailed: "删除失败",
    copyFailed: "复制失败",
  },
  shareModal: {
    selectChannelTitle: "请选择分享到的频道",
    channelLabel: "频道",
    channelPlaceholder: "请选择频道",
    alliance: "联盟",
    shareSuccess: "分享成功",
    continueBrowse: "继续浏览",
    goToGame: "前往游戏查看",
    noThreadTip: "请先在帖子详情页操作",
  },
  profile: {
    title: "个人中心",
    editNickname: "修改昵称",
    communityId: "社区ID",
    followers: "粉丝",
    follow: "关注",
    followSuccess: "关注成功",
    unfollowSuccess: "取消关注成功",
    addLikeSuccess: "点赞成功",
    cancelLikeSuccess: "取消点赞成功",
    likes: "获赞",
    tabs: {
      posts: "我的动态",
      favorites: "我的收藏",
    },
    followed: "已关注",
    noPosts: "暂无动态",
    noFavorites: "暂无收藏",
    shopLabel: "积分商城",
  },
  search: {
    btn: "搜索",
    hotTitle: "热搜",
    historyTitle: "历史搜索",
    tabs: {
      post: "帖子",
      user: "用户",
    },
    empty: "无相关搜索内容",
    filter: {
      title: "排序",
      views: "热门",
      dateline: "最新",
    },
    relatedPosts: "相关帖子",
  },
  nicknameModify: {
    placeholder: "请输入昵称",
    myCoins: "我的积分：",
    getMore: "获取",
    description: "修改昵称需要花费50积分，每月首次修改免費",
    alreadyRenamed: "每月只能修改一次昵称，您本月已经修改过了",
    sameNickname: "昵称不能与当前昵称相同",
    coinNotEnough: "积分不足",
    nicknameTooShort: "昵称不能少于3个字",
    viewRecord: "查看修改记录",
    recordTitle: "修改记录",
    date: "日期",
    changedNickname: "更改昵称",
    cost: "消耗",
    success: "修改成功",
  },
  shop: {
    title: "兑换中心",
    record: "兑换记录",
    emptyTip: "商铺正在搭建，敬请期待~",
    bindRole: "绑定角色",
    switchRole: "切换角色",
    tabs: {
      tasks: "积分任务",
      rewards: "奖励兑换",
    },
    taskInProgress: "进行中",
    taskCompleted: "已完成",
    goToComplete: "去完成",
    exchange: "兑换",
    exchanged: "已兑换",
    exchangeConfirmTitle: "是否兑换奖励？",
    currentCoins: "当前积分",
    costCoins: "消耗积分",
    receiveRole: "领取角色",
    exchangeSuccess: "兑换成功",
    exchangeFailed: "兑换失败",
  },
  exchangeRecord: {
    time: "时间",
    content: "内容",
    points: "积分",
    empty: "暂无兑换记录",
  },
  setting: {
    title: "设置",
    about: "关于我们",
    service: "服务条款",
    privacy: "隐私政策",
    logout: "退出登录",
    logoutSuccess: "已退出登录",
  },
  avatar: {
    title: "修改头像",
  },
  commentModal: {
    title: "评论",
    placeholder: "写评论...",
    replyTo: "回复{username}",
  },
  bindRole: {
    title: "绑定角色",
    modifyTitle: "修改绑定角色",
    server: "服务器：",
    role: "角色名：",
    serverPlaceholder: "请选择服务器",
    rolePlaceholder: "请选择角色",
    bindSuccess: "角色绑定成功",
    bindFailed: "角色绑定失败",
    getServerListFailed: "获取服务器列表失败",
    getRoleListFailed: "获取角色列表失败",
    noRole: "暂无角色",
    recentServers: "您的伺服器",
    allServers: "全部伺服器",
  },
  mentionModal: {
    title: "选择用户",
    searchPlaceholder: "搜索用户",
  },
  linkModal: {
    title: "插入链接",
    viewTitle: "查看链接",
    textLabel: "链接文本",
    textPlaceholder: "请输入链接文本",
    urlLabel: "链接地址",
    urlPlaceholder: "请输入链接地址",
    close: "关闭",
  },
  time: {
    minutesAgo: "{minutes}分钟前",
    hoursAgo: "{hours}小时前",
  },
  maintenance: {
    title: "页面维护中",
    message: "抱歉，当前游戏论坛正在维护中，请稍后再试。",
  },
  error: {
    common: "操作失败，请稍后再试",
    50002: "Token无效或过期",
    50301: "您没有发帖权限",
    50302: "发帖次数已达上限",
    50303: "内容长度不符合要求",
    50304: "内容包含敏感词，请修改后重试",
    50308: "您没有权限查看此帖子",
    50309: "帖子已被删除或移动",
    50351: "主题帖已关闭，无法回复",
    50353: "您没有回复权限",
    50354: "本版块禁止回复",
    50355: "发帖过于频繁，请稍后再试",
    50356: "每小时发帖数量已达上限",
    50361: "评论不存在",
    50500: "您没有搜索权限",
    50501: "搜索功能已关闭",
    50502: "内容包含敏感词，请修改后重试",
    50006: "该昵称已被其他用户使用",
    50007: "每月只能修改一次昵称，您本月已经修改过了",
    50008: "积分不足",
    50505: "搜索过于频繁，请稍后再试",
    50703: "图片审核不通过",
    50704: "图片内容不符合规范",
    50214: "分享失败，未加入@:shareModal.alliance",
  },
};
